<template>
    <div class="region-selection" @click="showDropDown = false">
        <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
        <form action="" class="form --teach-section-form --settings-form">
            <div class="region-selection-form">
                <div class="form-container">
                    <div class="form-wrapper">
                        <div class="country">Country</div>
                        <div class="condition">
                            <Multiselect 
                                v-model="selectedCondition" 
                                :options="conditions" 
                                :searchable="false" 
                                :close-on-select="true" 
                                :show-labels="false"
                                placeholder="Select Condition"
                                class="condition-dropdown">
                            </Multiselect>
                        </div>
                        <div class="region">
                            <Multiselect 
                                v-model="selectedCountries" 
                                :options="countries" 
                                :multiple="true" 
                                :searchable="false" 
                                :close-on-select="false"
                                track-by="name" 
                                label="name" 
                                placeholder="Select Country"
                                class="country-list">
                            </Multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="field --form-btn-holder">
                <div class="control --center-align">
                    <a href="" class="button --form-action-btn" @click.prevent="saveRegion()">Save</a>
                </div>
            </div>-->
        </form>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Multiselect from 'vue-multiselect';
import {unsavedChangesTitle, unsavedChangesSubtitle} from 'SrcRoot/mixins/modal';
import modalMixins from 'SrcRoot/mixins/modal';
import { isEmpty,isEqual, isNull,cloneDeep } from 'lodash';
import { handleFieldValidity } from 'SrcRoot/utils/validations';

export default {
    name: 'RegionSelection',
    data(){
        return{
            conditions:['is'],
            selectedCondition:'is',
            countries:[],
            showDropDown:false,
            isFullPage:false,
            //region_selection_id:null,
            selectedCountries:[],
            //region_condition_id:null,
            unsavedChangesTitle,
            unsavedChangesSubtitle,
            thisComponent:this,
            showDialog:false,
            gotonextroute:"",
            showLoader: false,
            default_region_country: {
                "region_country_id": "",
                "region_selection_id": 8,
                "country_id": 236,
                "selected_country": [{
                    "name": "USA",
                    "code": "US"
                }]
            },
            default_country: {
                "name": "USA",
                "code": "US",
                "country_id": 236,
                "status":1
            }
        }
    },
    /*beforeRouteLeave(to, from, next) {
        //this.gotonextroute = next;
        //if (!(this.isComponentDirty())) next(); // if not dirty  - allow to leave
        //else this.showDialog = true; // else ask whether save or discard or cancel
    },*/
    components:{
        Multiselect,
    },
    mixins: [
        modalMixins,
    ],
    computed: {
        ...mapGetters("campaigns", [
            "currentCampaign",
            "getCountryList",
            "getRegionSelectionData"
        ]),
        ...mapGetters('authentication', [
            'company'
        ]),
        /*...mapState('settings', {
            company: (state) => state.company
        }),*/
        region() {
            if (isEmpty(this.getRegionSelectionData)) {
                return {};
            }
            else return this.getRegionSelectionData[0];
        },
        region_selection_id() {
            if (this.region == undefined || isEmpty(this.region)) {
                return "";
            } else {
                return this.region.region_selection_id;
            }
        },
        region_condition_id() {
            if (this.region == undefined || isEmpty(this.region) || isEmpty(this.region.region_condition)) {
                return "";
            } else { 
                return this.region.region_condition[0].region_condition_id;
            }
        },
        region_country() {
            if (this.region == undefined || isEmpty(this.region)) {
                return [];
            } else {
                return this.region.region_country;
            }
        }
    },
    created() {
        this.init()
    },
    methods:{
        init() {
            this.$store.dispatch('campaigns/ui/showLoader');
            const promise1 = this.$store.dispatch('campaigns/setCountryList')
            const promise2 = this.$store.dispatch('campaigns/getRegionSelection',{
                data: {
                    campaign_id:this.currentCampaign.id,
                }
            });
            Promise.all([promise1,promise2]).then(()=>{
                this.mapRegionSelection()
                this.$store.dispatch('campaigns/ui/hideLoader');
                this.initSelectedCountries();
            })
        },
        initSelectedCountries() {
            if (!isEmpty(this.selectedCountries)) {
                return;
            }
            this.selectedCountries.push(this.default_country);
        },
        saveRegion(){
            if (!(this.isComponentDirty())) {
                return;
            }
            let selected_country =[]
            this.selectedCountries.forEach(e => {
                selected_country.push({
                    "region_country_id": e.region_country_id || '',
                    "country_id": e.country_id
                })
            }); //console.log(this.selectedCountries);
            let region_selection= [
                {
                    "region_selection_id": this.region_selection_id || '',
                    "selected_condition":{
                        "region_condition_id": this.region_condition_id || '',
                        "condition": this.selectedCondition
                    },
                    "selected_country": selected_country
                }
            ];
           
            this.showLoader = true;
            this.$store.dispatch('campaigns/ui/showLoader');
            return this.$store.dispatch('campaigns/addOrUpdateRegionSelection',{
                data: {
                    campaign_id:this.currentCampaign.id,
                    region_selection: {
                        region_selection
                    }
                }
            })
            .then((responseData) => {
                this.updateSelectedCountryList(responseData);
                this.$store.dispatch('campaigns/ui/hideLoader');
                this.showLoader = false;
                if (typeof this.gotonextroute === 'function') { // go to next route 
                    this.gotonextroute();
                }
            });
        },
        _saveOrUpdateForm() { 
            this.saveRegion();
        },
        mapRegionSelection(){
            this.countries = [...this.getCountryList];
            if (!isEmpty(this.region)) {
                if ((isEmpty(this.region_country))) {
                    this.selectedCountries.push(cloneDeep(this.default_region_country));
                    this._saveOrUpdateForm();
                } else {
                    this.region_country.forEach((element) => {
                    this.selectedCountries.push({
                            ...element,
                            ...element.selected_country[0]
                        });
                    this.countries.forEach((e) => {
                            if(element.country_id === e.country_id) {
                                e.region_country_id = element.region_country_id
                            }
                        });
                    });
                }
            }
        },
        extractCountriesSelected(regions) {
            let countries = [], country;
            if (regions == undefined) return countries;
            regions.forEach((region) => {
                // todo below is a kludge - something odd about how user selection is being collected
                // need to fix it - so that the below if is not required
                if ((region.selected_country == undefined) && (region.code != undefined))
                    countries.push(region.code);
                else if ((region.selected_country != undefined) && !(isEmpty(region.selected_country))) {
                    [country] = region.selected_country;
                    countries.push(country.code);
                }
            });
            return countries;
        },
        isComponentDirty() {
            if (isEmpty(this.region) && isEmpty(this.selectedCountries)) return false; // not dirty;
            else if ((this.region == undefined) && !(isEmpty(this.selectedCountries))) return true; // dirty
            else { 
                let fromSelectedRegions = this.region_country;
                if ((fromSelectedRegions == undefined)  && !(isEmpty(this.selectedCountries))) return true;
                else if (fromSelectedRegions.length != this.selectedCountries.length) return true;
                else {
                    let fromCountries = this.extractCountriesSelected(fromSelectedRegions),
                        toCountries = this.extractCountriesSelected(this.selectedCountries)
                    return (!(isEqual(fromCountries.sort(), toCountries.sort()))); 
                }
            }
            
        },
        updateCountries() {
            let selected_countries = this.extractCountriesSelected(this.selectedCountries);
            let countryList = [...this.getCountryList];
            this.countries = countryList.filter(country => !selected_countries.includes(country.code));

        },

        updateSelectedCountryList(responseData) {
            const {region_selection_id, region_country} = responseData.data[0];
            for (let selectedCountry of this.selectedCountries) {
                if (selectedCountry.region_country_id === undefined) {
                    const matchingRegion = region_country.find(region =>
                        region.country_id === selectedCountry.country_id
                    );
                    // If a matching region is found, update selected_country in selectedCountries
                    if (matchingRegion) {
                        selectedCountry.region_country_id = matchingRegion.region_country_id;
                        selectedCountry.region_selection_id = matchingRegion.region_selection_id;
                        selectedCountry.selected_country = matchingRegion.selected_country;
                    }
                }
            }
        }

    },
    watch: {
        selectedCountries: {
            deep: true,
            handler(to, from) { 
               
                this.updateCountries();
                if (to === undefined || isEmpty(to) || isEqual(to, from)) {
                    return;
                } else {
                    //this.updateCountries();
                    this.saveRegion()
                }
            }
        },
    }
}
</script>
<style lang="scss">
@import "SrcRoot/modules/Campaign/components/setup/scss/setup.scss";
</style>
